import { BaseOption } from "@npm_leadtech/qr-ui-components";

export const toFrameBaseOptions = (options: string[]): BaseOption[] => {
  return options.map((option, index) => ({
    value: (index + 1).toString(),
    label: option,
  }));
};
